var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,2.99742191 C1,1.89427625 1.89092539,1 2.99742191,1 L18.0025781,1 C19.1057238,1 20,1.89092539 20,2.99742191 L20,18.0025781 C20,19.1057238 19.1090746,20 18.0025781,20 L2.99742191,20 C1.89427625,20 1,19.1090746 1,18.0025781 L1,2.99742191 Z M4,4 L4,17 L17,17 L17,4 L4,4 Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  cx: 7.5,
  cy: 7.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.26800227,12.5229568 L12,16.9982407 L3,16.9982407 L6.73199773,12.5229568 C7.08570691,12.0988008 7.71629119,12.0416925 8.14044712,12.3954016 C8.18672146,12.4339904 8.22941349,12.4766824 8.26800227,12.5229568 Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3395702,9.88330395 L19,17.0857864 L8,17.0857864 L12.6604298,9.88330395 C12.9604592,9.41962216 13.5795695,9.28695568 14.0432513,9.58698507 C14.1618438,9.66372138 14.2628338,9.76471147 14.3395702,9.88330395 Z",
  fill: "currentColor"
}))));
export default SvgImage;